import React from "react";
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { CustomForm, CustomInput, CustomSelect } from '../../../../fgs';
import { resourceValidations, resourceValidationMessages } from '../../../validations';

import { resourceCategoryOptions } from "../../../../services/selectOptions";

const EditForm = (props) => {
  const { form, onSave, setForm, setShowForm } = props;

  const onSelectChange = (name, selected) => {
    const selectedValue = selected ? selected : {};
    const newForm = Object.assign({}, form);
    newForm[name] = selectedValue.value;

    setForm(newForm);
  };

  const onInputChange = (e) => {
    const newForm = Object.assign({}, form);
    newForm[e.target.name] = e.target.value;

    setForm(newForm);
  };

  const formControls = [
    { title: 'Salvar', props: { type: 'submit', color: 'primary' } },
    { title: 'Modo Leitura', props: { onClick: setShowForm, color: 'secondary' } }
  ];

  return (
    <CustomForm
      validationMessages={resourceValidationMessages}
      validations={resourceValidations}
      form={form}
      formControls={formControls}
      onSubmit={onSave}>
      <Row>
        <Col xs="4">
          <CustomSelect
            labelText="Tipo"
            inputName="category"
            options={resourceCategoryOptions}
            selected={form.category}
            onChange={onSelectChange} />
        </Col>
      </Row>

      <Row>
        <Col xs="6">
          <CustomInput
            labelText="Nome"
            hasIcon={true}
            iconName="User"
            iconPosition="prepend"
            inputName="name"
            placeholder="Nuvem de pontos ...."
            onChange={onInputChange}
            inputValue={form.name} />
        </Col>

        <Col xs="6">
          <CustomInput
            labelText="Caminho"
            hasIcon={true}
            iconName="User"
            iconPosition="prepend"
            inputName="path"
            placeholder="Nuvem de pontos ...."
            onChange={onInputChange}
            inputValue={form.path} />
        </Col>
      </Row>
    </CustomForm>
  );
};

EditForm.propTypes = {
  form: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  setShowForm: PropTypes.func.isRequired,
  setForm: PropTypes.func.isRequired
};

export default EditForm;